import React, { useEffect } from "react";
import { FiStar, FiDollarSign, FiZap, FiLock, FiSmartphone, FiPhoneCall, FiCheckCircle } from "react-icons/fi";
import "./PaisaDaily.css";

function PaisaDaily() {
  // Prevent navigation away from this page
  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = function () {
      window.history.pushState(null, "", window.location.href);
    };

    return () => {
      window.onpopstate = null;
    };
  }, []);

  const handleApplyNow = () => {
    window.open("https://www.paisadaily.money/r/KUBERSETU/sms", "_blank");
  };

  return (
    <div className="paisadaily-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <span className="hero-badge"><FiStar /> Instant Loans</span>
          <h1 className="hero-title">
            Get Your Loan <br />
            <span className="hero-highlight">Approved Instantly</span>
          </h1>
          <p className="hero-description">
            Fast, Secure & Hassle-Free Loan Application Process
          </p>
          <div className="hero-actions">
            <button onClick={handleApplyNow} className="btn-primary">
              Apply Now on paisadaily
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </button>
          </div>
          <div className="hero-stats">
            <div className="stat-item">
              <span className="stat-number">50K+</span>
              <span className="stat-label">Happy Customers</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <span className="stat-number">₹5Cr+</span>
              <span className="stat-label">Disbursed</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <span className="stat-number">4.8★</span>
              <span className="stat-label">Rating</span>
            </div>
          </div>
        </div>
        <div className="hero-visual">
          <div className="floating-card card-1">
            <span><FiDollarSign /></span>
            <p>Low Interest</p>
          </div>
          <div className="floating-card card-2">
            <span><FiZap /></span>
            <p>Quick Approval</p>
          </div>
          <div className="floating-card card-3">
            <span><FiLock /></span>
            <p>100% Secure</p>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="section-header">
          <span className="section-tag">Why PaisaDaily?</span>
          <h2 className="section-title">Designed for Your <span>Financial Freedom</span></h2>
          <p className="section-subtitle">Experience a seamless loan application process with benefits tailored for you</p>
        </div>

        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon"><FiZap /></div>
            <h3>Quick Approval</h3>
            <p>Get loan approval within 24 hours with minimal documentation</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon"><FiDollarSign /></div>
            <h3>Low Interest Rates</h3>
            <p>Competitive rates starting from just 8.5% per annum</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon"><FiSmartphone /></div>
            <h3>100% Digital Process</h3>
            <p>Complete your application online without any physical paperwork</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon"><FiLock /></div>
            <h3>Secure & Safe</h3>
            <p>Your data is encrypted and protected with bank-grade security</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon"><FiPhoneCall /></div>
            <h3>24/7 Support</h3>
            <p>Dedicated customer support to assist you at every step</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon"><FiCheckCircle /></div>
            <h3>No Hidden Charges</h3>
            <p>Transparent process with zero hidden fees or charges</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>Ready to Get Started?</h2>
          <p>Join thousands of satisfied customers who got their loans approved with PaisaDaily</p>
          <button onClick={handleApplyNow} className="btn-secondary">
            Apply Now
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </button>
          <span className="cta-note">*By clicking Apply Now, you'll be redirected to PaisaDaily's secure portal</span>
        </div>
      </section>

      {/* Customer Care Section */}
      <section className="support-section">
        <div className="support-content">
          <div className="support-text">
            <span className="support-icon"><FiPhoneCall /></span>
            <h3>Need Help?</h3>
            <p>Our dedicated support team is here to assist you with your loan application.</p>
          </div>
          <a href="tel:+919008743131" className="support-phone">
            Call +91 9008743131
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="paisadaily-footer">
        <p>&copy; 2024 PaisaDaily. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default PaisaDaily;